module.exports = __webpack_public_path__ + "img/07.088908d4.jpg";